<template>
  <div>
    <a-card title="销量排序">
      <a-row gutter="16">
        <a-col :span="24" :md="10" :xl="8" style="margin-bottom: 12px;">
          <a-radio-group v-model="radioValue" button-style="solid" @change="changeRadio">
            <a-radio-button value="all">全部</a-radio-button>
            <a-radio-button value="-6">近7天</a-radio-button>
            <a-radio-button value="-29">近30天</a-radio-button>
            <a-radio-button value="-364">近一年</a-radio-button>
          </a-radio-group>
        </a-col>
        <a-col :span="24" :md="8" :xl="6" style="max-width: 280px; margin-bottom: 12px;">
          <a-range-picker v-model="dateRange" @change="changeDate" style="width: 100%;" />
        </a-col>
        <a-col :span="24" :md="6" :xl="5" style="max-width: 256px; margin-bottom: 12px;">
          <a-input-search v-model="searchForm.search" placeholder="产品编号/名称" allowClear @search="search" />
        </a-col>
      </a-row>
      <a-alert
        type="info"
        showIcon
        style="margin-bottom: 12px;"
        message="按净卖出（卖出 − 销售退货）从高到低。进货已扣采购退货。点「经销商」看每个客户卖了多少。"
      />
      <a-table
        size="small"
        rowKey="goods"
        :columns="columns"
        :dataSource="items"
        :loading="loading"
        :pagination="pagination"
        @change="tableChange"
      >
        <span slot="action" slot-scope="value, item">
          <a @click="openDealers(item)">经销商</a>
        </span>
      </a-table>
    </a-card>

    <a-drawer
      :title="drawerTitle"
      :visible="drawerVisible"
      width="640"
      @close="drawerVisible = false"
    >
      <a-descriptions size="small" :column="2" style="margin-bottom: 16px;">
        <a-descriptions-item label="进货">{{ current.purchase_quantity }} {{ current.unit_name }}</a-descriptions-item>
        <a-descriptions-item label="卖出">{{ current.sales_quantity }} {{ current.unit_name }}</a-descriptions-item>
        <a-descriptions-item label="退货">{{ current.return_quantity }} {{ current.unit_name }}</a-descriptions-item>
        <a-descriptions-item label="净卖出">{{ current.net_quantity }} {{ current.unit_name }}</a-descriptions-item>
      </a-descriptions>
      <a-table
        size="small"
        rowKey="client"
        :columns="dealerColumns"
        :dataSource="dealers"
        :loading="dealerLoading"
        :pagination="false"
      />
    </a-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import { salesRankList, salesRankDealers } from '@/api/report'

export default {
  name: 'SalesRank',
  data() {
    return {
      radioValue: 'all',
      dateRange: [],
      searchForm: { page: 1, page_size: 16, search: '' },
      pagination: { current: 1, total: 0, pageSize: 16 },
      loading: false,
      items: [],
      drawerVisible: false,
      dealerLoading: false,
      current: {},
      dealers: [],
      columns: [
        { title: '序号', customRender: (v, i, index) => index + 1, width: 50 },
        { title: '产品名称', dataIndex: 'goods_name' },
        { title: '编号', dataIndex: 'goods_number', width: 140 },
        { title: '进货', dataIndex: 'purchase_quantity', customRender: (v, item) => `${v} ${item.unit_name || ''}` },
        { title: '卖出', dataIndex: 'sales_quantity', customRender: (v, item) => `${v} ${item.unit_name || ''}` },
        { title: '退货', dataIndex: 'return_quantity', customRender: (v, item) => `${v} ${item.unit_name || ''}` },
        { title: '净卖出', dataIndex: 'net_quantity', customRender: (v, item) => `${v} ${item.unit_name || ''}` },
        { title: '销量第一', dataIndex: 'top_client_name', customRender: (v) => v || '—' },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 80 },
      ],
      dealerColumns: [
        { title: '排名', customRender: (v, i, index) => index + 1, width: 60 },
        { title: '经销商', dataIndex: 'client_name' },
        { title: '卖出', dataIndex: 'sales_quantity', customRender: (v, item) => `${v} ${item.unit_name || ''}` },
        { title: '退货', dataIndex: 'return_quantity', customRender: (v, item) => `${v} ${item.unit_name || ''}` },
        { title: '净卖出', dataIndex: 'net_quantity', customRender: (v, item) => `${v} ${item.unit_name || ''}` },
      ],
    }
  },
  computed: {
    drawerTitle() {
      return this.current.goods_name ? `${this.current.goods_name} · 经销商销量` : '经销商销量'
    },
  },
  methods: {
    dateParams() {
      const form = {
        search: this.searchForm.search || undefined,
        page: this.searchForm.page,
        page_size: this.searchForm.page_size,
      }
      if (this.dateRange && this.dateRange.length === 2 && this.dateRange[0]) {
        form.start_date = this.dateRange[0].format('YYYY-MM-DD')
        form.end_date = moment(this.dateRange[1]).add(1, 'days').format('YYYY-MM-DD')
      }
      return form
    },
    list() {
      this.loading = true
      salesRankList(this.dateParams())
        .then((data) => {
          this.pagination.total = data.count || 0
          this.items = data.results || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeRadio() {
      const v = this.radioValue
      if (v === 'all') {
        this.dateRange = []
      } else {
        const days = Number(v)
        this.dateRange = [moment().add(days, 'days').startOf('day'), moment().startOf('day')]
      }
      this.search()
    },
    changeDate(dates) {
      this.dateRange = dates || []
      this.radioValue = dates && dates.length ? '' : 'all'
      this.search()
    },
    search() {
      this.searchForm.page = 1
      this.pagination.current = 1
      this.list()
    },
    tableChange(pagination) {
      this.searchForm.page = pagination.current
      this.pagination.current = pagination.current
      this.list()
    },
    openDealers(item) {
      this.current = item
      this.dealers = []
      this.drawerVisible = true
      this.dealerLoading = true
      const params = {}
      if (this.dateRange && this.dateRange.length === 2 && this.dateRange[0]) {
        params.start_date = this.dateRange[0].format('YYYY-MM-DD')
        params.end_date = moment(this.dateRange[1]).add(1, 'days').format('YYYY-MM-DD')
      }
      salesRankDealers(item.goods, params)
        .then((data) => {
          this.current = { ...this.current, ...data }
          this.dealers = (data && data.dealers) || []
        })
        .finally(() => {
          this.dealerLoading = false
        })
    },
  },
  mounted() {
    this.list()
  },
}
</script>
